module.exports = __webpack_public_path__ + "img/二手车.00ba1cbc.png";